import { PHeadline } from '@porsche-design-system/components-react'
import React from 'react'

import { ReportingContext } from '../../../../utils/Context/ReportingContext'
import { headlinesAppWithSubApps } from '../../../../utils/ratingService'
import Panel from '../../../Panel/Panel'
import TableWithAction from '../TableWithAction/TableWithAction'

type DataSorting = {
  additionalInformation: any
  col0: string
  col1: string
}

type Props = {
  content: DataSorting[]
  loading: boolean
}

const TableSubApps: React.FC<Props> = ({ content, loading }) => {
  const { filter, setFilter, setContentHeader, setResetParams, chosenApplication, appId, setOpenSubApps } =
    React.useContext(ReportingContext)

  const [data, setData] = React.useState(content)

  const rowClickHandler = (item: any) => {
    if (item.additionalInformation.appType !== 'subApp' && item.additionalInformation.appType !== 'module') {
      setFilter({ ...filter, app: [appId], subApp: [], module: [] })
      setContentHeader(chosenApplication)
    }
    if (item.additionalInformation.appType === 'subApp') {
      setFilter({ ...filter, app: [appId], subApp: [item.additionalInformation.id], module: [] })
      setContentHeader(chosenApplication + ' / ' + item.col0)
    }
    if (item.additionalInformation.appType === 'module') {
      setFilter({
        ...filter,
        app: [appId],
        subApp: [item.additionalInformation.subAppId],
        module: [item.additionalInformation.id]
      })
      setContentHeader(chosenApplication + ' / ' + item.additionalInformation.subAppName + ' / ' + item.col0)
    }
    setResetParams(true)
  }

  React.useEffect(() => {
    setData(content)
  }, [content])

  React.useEffect(() => {
    if (loading) {
      setData([])
    }
  }, [loading])

  return (
    <>
      <PHeadline variant='headline-5'>Bereiche</PHeadline>
      <Panel withMargin withPadding>
        <TableWithAction
          caption='Bereiche'
          content={data}
          headlines={headlinesAppWithSubApps}
          loading={loading}
          rowClicker={rowClickHandler}
        />
      </Panel>
    </>
  )
}

export default React.memo(TableSubApps)
